import { Injectable } from '@angular/core';
import { LoginConfigService, LoginType } from 'gung-standard';
import { CultLoginComponent } from '../components/cult-login/cult-login.component';

@Injectable({
  providedIn: 'root'
})
export class CultLoginConfigService extends LoginConfigService {
  getLoginType() {
    return LoginType.FashionLogin;
  }

  getLoginComponent(loginType?) {
    return CultLoginComponent;
  }
}
